import type { BeamSegment } from "../sim/types";
import type { Renderer } from "./renderer";

/** Bit 128 in tiles.wgsl flags. Bypasses the atlas sample entirely — the
 *  registered "mining_beam" sprite is a no-op stub. */
const FLAG_MINING_BEAM = 128;

export function pushBeamTiles(r: Renderer, beams: Iterable<BeamSegment>): void {
  for (const b of beams) {
    const uv = r.atlas.lookup.get(b.sprite);
    if (!uv) continue;
    const dx = b.toX - b.fromX;
    const dy = b.toY - b.fromY;
    const len = Math.hypot(dx, dy);
    if (len < 1e-3) continue;
    const isMining = b.sprite === "mining_beam";
    r.pushTileRaw(
      (b.fromX + b.toX) * 0.5,
      (b.fromY + b.toY) * 0.5,
      len, b.widthM * 2,
      Math.atan2(dy, dx), isMining ? FLAG_MINING_BEAM : 0,
      uv.u, uv.v, uv.w, uv.h,
      0, 0, 1.0,
      b.vx, b.vy, 0,
    );
  }
}
